export const ApiCommonBaseUrl = `/orderApi`

export const ApiBaseUrl = `/orderApi/orderSheet/seller`

export const CommonApiUrlInfo = {
    /** 제휴 포인트 조회 */
    affiliatePoint: '/orderSheet/affiliatePoint/v2',
}

export const ApiUrlInfo = {
    /** 주문서 조회 */
    orderSheet: '/',
    waiting: {
        /** 주문서 진입 가능 여부 판단 */
        state: '/waiting/state',
        /** 대기열 초기 정보 조회 */
        info: '/waiting/info',
    },
    /** 맴버십 퀵조인 */
    membershipJoin: '/memberships/join',
    payPoint: {
        /** 충전포인트와 적립포인트 잔액 재조회 */
        naverpayPointBalance: '/naverpayPointBalance',
        /** 적립 포인트 잔액 재조회 */
        rewardPointBalance: '/rewardPointBalance',
        /** 충전포인트 잔액 재조회 */
        chargePointBalance: '/chargePointBalance',
        /** 충전포인트 충전 가능 금액 재조회 */
        rechargeableChargePoint: '/rechargeableChargePoint',
    },
    payLater: {
        /** 후불결제 정보 재조회 */
        reload: '/payLater',
        /** 후불결제 튜토리얼 미노출 처리 */
        tooltipClosed: '/paylater/tutorial/close',
    },
    payments: {
        /** 카드 간편결제 정보 재조회 */
        cardEasyPaysReload: '/cardEasyPays',
        /** 계좌 간편결제 정보 재조회 */
        bankEasyPaysReload: '/bankEasyPays',
    },
    delivery: {
        /** 배송지 목록, 최근 배송지 조회 */
        address: '/deliveries/address',
        /** 배송지 목록 조회 */
        addressBooks: '/deliveries/addressBooks',
        /** 배송지 목록 추가 가능 여부 확인 */
        insertable: '/deliveries/addressBooks/insertable',
        /** 최근 배송지 삭제 */
        recentAddresses: '/deliveries/recentAddresses',
        /** 변경 후 재계산 요청 */
        deliveryFee: '/deliveries/fee',
        /** 가주문 생성 전 도착보장 상품의 배송정보 변경 여부 체크 */
        arrivalGuaranteeValidate: 'arrivalGuaranteeValidate',
    },
    // PC 에서 별도로 쿠폰 조회를 하지 않음 (확인필요)
    coupon: {
        /** 상품 할인 쿠폰 조회 */
        product: '/coupons/product',
        /** 배송비 쿠폰 조회 */
        deliveryFee: '/coupons/deliveryFee',
        /** 내 쿠폰 조회 */
        myCoupon: '/coupons/myCoupons',
        /** 상품 할인금액 조회 */
        productDiscount: '/coupons/discount',
    },
    expectedRewardPoint: '/expectedRewardPoint',
}
